import {FC} from 'react';
import {SxProps, Theme, Typography} from '@mui/material';
import {FormattedMessage, useIntl} from 'react-intl';
import theme from 'src/theme';
import {pillFitSx} from 'src/components/common/pillFit.sx';
import {useFitText} from 'src/hooks/useFitText';

/**
 * Whether the invited person has chosen a password yet.
 *
 * Two states, because that is all the record can be in: nobody types a password for somebody else
 * here, so a credential is either in use or still an outstanding invitation.
 */
export const CredentialStatus: FC<{passwordSet: boolean}> = ({passwordSet}) => {
    const intl = useIntl();
    // The platform's own status vocabulary: ACTIVATED is the word every other status pill already
    // uses for a login that works. The pending half needs a key of its own - PENDING_HASH reads as
    // "Ausstehende Validierung", which is a narrower claim, and a bare PENDING exists in English only.
    const label = passwordSet ? 'ACTIVATED' : 'credentialPending';
    const fitRef = useFitText<HTMLSpanElement>(`${intl.locale}:${label}`);

    const sxValue: SxProps<Theme> = {
        background: passwordSet ? theme.palette.success.light : theme.palette.primaryColor[50],
        color: passwordSet ? theme.palette.success.dark : theme.palette.primaryColor[700],
        padding: theme.spacing(3 / 8, 6 / 8),
        borderRadius: theme.spacing(4 / 8),
        fontWeight: 500,
        ...pillFitSx,
        [theme.breakpoints.down('md')]: {
            fontSize: theme.spacing(12 / 8),
        },
    };

    return (
        <Typography
            ref={fitRef}
            sx={sxValue}
            component="span"
        >
            <FormattedMessage id={label}/>
        </Typography>
    );
};
